<template>
  <el-select
    ref="select"
    v-if="forceReloadFlag"
    v-model="theValue"
    remote
    :class="{ 'select2-hide-icon': isHide }"
    :remote-method="searchOptions"
    :loading="searchLoading"
    :name="name"
    :size="size"
    :disabled="disabled"
    :clearable="clearable"
    :filterable="filterable"
    :allowCreate="allowCreate"
    :popperClass="popperClass"
    :loadingText="loadingText"
    :noMatchText="noMatchText"
    :noDataText="noDataText"
    :filterMethod="filterMethod"
    :multiple="multiple"
    :multipleLimit="multipleLimit"
    :placeholder="placeholder"
    :defaultFirstOption="defaultFirstOption"
    :valueKey="valueKey"
    :collapse-tags="collapseTags"
    @change="selected"
    @visible-change="visibleChange"
  >
    <!--原本的key是option[valueKey]-->
    <el-option
      v-for="(option, index) in optionList"
      :value="useValueObject ? option : option[valueKey]"
      :label="processLabel(option)"
      :key="index"
    >
      <slot :scope="option"></slot>
    </el-option>
    <!--
      使用形式，这是一个例子，也可以自己写其它样式的,如果想选择之后的input上也显示和option一样的格式，要使用labelName中的function的形式去定义，不过这样的话值只能都在左侧了
      <template scope="{scope}">
        <span class="pull-left">{{scope.label}}</span>
        <span class="pull-right text-xs">{{scope.ohtervalue}}</span>
      </template>
    -->
    <p v-if="moreLoading" class="el-select-dropdown__empty">等待加载...</p>
  </el-select>
</template>

<script>
/*
 * currentList 是初始化设置值，但必须是数组，单选即数组就一项
 * 如果非空字符串为空值显示，如id是0的显示空，需要设置emptyValue = 0;
 * 默认不点击输入框不触发初始查询，如果需要点击框前加载空字符串查询结果需要设置queryInit = true
 */

// 只适用于分页远程查询
export default {
  components: {},
  data() {
    return {
      optionList: [],
      searchLoading: false,
      moreLoading: false,
      theValue: "",
      more: false,
      nextPage: 2,
      query: "",
      initOptionList: this.currentList, // 初始值
      adding: false, // 防止addMore请求还没结束连续请求
      // defaultOptions()时是否可查询标志，不可查询时会置为false,在下拉框出现时查询，并置为true
      canQuery: true,
      forceReloadFlag: true,
    };
  },
  // 所有属性
  props: {
    // remote request url
    url: {
      type: String,
      // required: true,
    },
    // request with extra params
    urlParams: {
      type: Object,
      default() {
        return {};
      },
    },
    // init value options
    currentList: {
      type: Array,
      default() {
        return [];
      },
    },
    // the key of option label
    labelName: {
      type: [String, Function],
      default: "Name",
    },
    name: String,
    value: {
      required: true,
    },
    size: String,
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
    filterable: {
      type: Boolean,
      default: true,
    },
    allowCreate: Boolean,
    // loading: Boolean,
    popperClass: String,
    // remote: Boolean,
    loadingText: String,
    noMatchText: String,
    noDataText: String,
    // remoteMethod: Function,
    filterMethod: Function,
    multiple: Boolean,
    multipleLimit: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
    },
    defaultFirstOption: Boolean,
    valueKey: {
      type: String,
      default: "ID",
    },
    useValueObject: {
      type: Boolean,
      default: false,
    },
    multipleClear: {
      type: Boolean,
      default: true,
    },
    // 设置空值
    emptyValue: {
      default: "",
    },
    firstOption: {
      type: Object,
    },
    // 是否在点开前提前查询
    queryInit: {
      default: false,
    },
    // 是否根据id查询一组数据，避免仅显示id
    queryOne: {
      type: Boolean,
      default: true,
    },
    // 多选时，多个时除了第一个显示tag文字，其它为+数字
    collapseTags: {
      type: Boolean,
      default: true,
    },
    q: {
      type: String,
      default: "q",
    },
    qinwhere: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.init();
  },
  created() {
    this.debounceQuery = _.debounce(this.queryRemote, 300);
  },
  computed: {
    // select2 添加的下拉标签箭头需要隐藏时添加的class,即清空图标显示时
    isHide() {
      return (
        this.clearable &&
        !this.disabled &&
        !this.multiple &&
        this.theValue !== undefined &&
        this.theValue !== ""
      );
    },
  },
  methods: {
    init() {
      const wrap =
        this.$refs.select.$refs.popper.$el.getElementsByClassName(
          "el-scrollbar__wrap"
        )[0];
      // throttle 防止频繁调用比较
      const checkScroll = _.throttle(() => {
        if (wrap.scrollHeight - 1 < wrap.scrollTop + wrap.clientHeight) {
          // 非标准比例尺寸是浮点数，加入一些余量
          this.addMoreOptions();
        }
      }, 200);
      wrap.addEventListener("scroll", checkScroll);
      // 原生remote没有选择框下拉的图标，需手动添加，
      // 有clearable的关闭按钮时(computed:isHide控制)要用css: .select2-hide-icon el-input:hover .remote-under-icon {dispaly:none;}
      const inputDom = this.$refs.select.$refs.reference.$el;
      if (inputDom.getElementsByClassName("el-input__icon").length === 0) {
        const iconDom = document.createElement("i");
        if (iconDom.classList) {
          iconDom.classList.add(
            "el-input__icon",
            "el-icon-caret-top",
            "remote-under-icon"
          );
        } else {
          iconDom.className =
            "el-input__icon el-icon-caret-top remote-under-icon";
        }
        inputDom.appendChild(iconDom);
      }
      // 赋初始值
      this.defaultOptions();
    },
    // 初始值改变时赋初值，和v-model有重复效果。因为当optionList没有值，v-model没有labeName无法赋初值
    defaultOptions() {
      // 当初始值存在于optionList时 不重新发请求查询
      const curListIds = this.optionList.map((item) => item[this.valueKey]);
      let isContain = true;
      if (curListIds.length === 0) {
        isContain = false;
      }
      for (let j = 0; j < this.initOptionList.length; j++) {
        // options里没有找到initOptionList
        if (curListIds.indexOf(this.initOptionList[j][this.valueKey]) === -1) {
          isContain = false;
          break;
        }
      }
      if (isContain && this.initOptionList.length > 0) {
        return;
      }
      // 不知道上面以前怎么想的，统一都赋值初始options，都用nextTick也没有问题
      // 之前没有canQuery上面这么写没问题，都会更新options,该组件改动较多，尽量包容
      if (this.initOptionList.length > 0) {
        this.optionList = this.initOptionList;
        this.forceReloadFlag = false;
        this.$nextTick(() => {
          this.theValue = this.multiple
            ? this.initOptionList.map((item) => item[this.valueKey])
            : this.initOptionList[0][this.valueKey];
          this.forceReloadFlag = true;
          this.$nextTick(this.init);
        });
      }
      if (this.queryInit) {
        // 带初始值查询
        this.searchOptions("", true);
      } else if (
        this.queryOne &&
        this.initOptionList.length === 0 &&
        this.value &&
        (_.isString(this.value) ||
          _.isNumber(this.value) ||
          (_.isArray(this.value) && this.value.length === 1))
      ) {
        this.queryOneOption();
      } else {
        this.canQuery = false;
      }
    },
    searchOptions(query, withInitVal = false) {
      // 多选时el-select没有debounce,要手动加
      if (this.multiple && query) {
        this.debounceQuery(query, withInitVal);
      } else {
        this.queryRemote(query, withInitVal);
      }
    },
    queryOneOption() {
      if (!this.url || !this.value || this.currentList.length > 0) {
        return;
      }
      this.$axios
        .get(`${this.url.replace(/\?.*$/, "")}/${this.value}`)
        .then((resp) => {
          this.initOptionList = [resp.data];
          this.defaultOptions();
        });
    },
    // 1.el-select @remote-method，触发条件是输入框filterable=true, 输入框内容改变时触发
    // 2.还有远程分页不可筛选初始化触发（自己加的功能）
    queryRemote(query, withInitVal = false) {
      // 当下拉框不显示的时候，queryInit为false时，不后台查询
      if (!this.$refs.select.visible && !this.queryInit) {
        return;
      }
      // 此版本的select的一些问题，需要注意防止多次查询，新版本会修复一下
      // 如果filterable=true,el-select 初始化的时候会触发一次 query = undefined
      // theValue 改变时会触发query = theVlaue,
      // 单选模式下选中时会触发 输入框的input 事件，而输入框的input 会触发 query = 输入框的value
      // 如果是单选可检索时，当前要查的值存在于options里时不查询，为了防止选中后再查一次的bug
      // 不好的地方是，如果是当前显示label值的超集（如 当前值是'abc',筛选文字也是'abc'）也不会查询
      if (!this.multiple && this.optionList.length > 0) {
        if (query === this.theValue && this.theValue) {
          return;
        }
        const option = _.find(this.optionList, [this.valueKey, this.theValue]);
        if (
          (option ? this.processLabel(option) : false) === query &&
          this.filterable
        ) {
          return;
        }
      }
      // tag 不远程查询模式 一般不会有，因为可以直接用el-select组件，不要用这个插件了//
      if (!this.url) {
        // this.optionList = [];
        this.more = false;
        return;
      }
      // 远程查询默认分页
      const params = { return_list: 0, ...this.urlParams };
      // if (typeof query === 'string' && query.trim() !== '') {
      //修改原因：如果加判断为空，查询时一直按退格键清空查询还是会带最后的值
      if (typeof query === "string") {
        if (this.qinwhere) {
          params.where[this.q] = query;
        } else {
          params[this.q] = query;
        }
      }
      this.paramsStore = { ...this.urlParams };
      // 记录下一页addMore使用的query参数
      this.query = query;
      this.searchLoading = true;
      this.$axios.get(this.url, { params }).then(
        (response) => {
          this.searchLoading = false;
          // 分页返回
          if (params.return_list === 0) {
            if (withInitVal) {
              // 因为分页加载，有初始值要去重
              this.optionList = this.listProcess(
                this.initOptionList,
                response.data.data
              );
            } else {
              this.optionList = response.data.data;
            }
            // 是否有下一页
            this.more = response.data.last > response.data.page;
            this.nextPage = response.data.page + 1;
          } else {
            // 不分页
            this.optionList = response.data;
            this.more = false;
          }
          if (
            this.firstOption &&
            _.findIndex(this.optionList, this.firstOption) === -1
          ) {
            this.optionList.unshift(this.firstOption);
          }
        },
        ({ response }) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    // option label 显示
    processLabel(option) {
      let result = option[this.labelName];
      if (typeof this.labelName === "function") {
        result = this.labelName(option);
      }
      return result;
    },
    addMoreOptions() {
      if (this.adding) {
        return;
      }
      this.adding = true;
      if (!this.more) {
        this.adding = false;
        return;
      }
      const params = { return_list: 0, ...this.urlParams };
      params.q = this.query;
      params.page = this.nextPage;
      this.moreLoading = true;
      this.$axios
        .get(this.url, { params })
        .then(
          (response) => {
            this.moreLoading = false;
            const moreList = response.data.data;
            if (this.initOptionList.length > 0) {
              this.optionList = this.listProcess(this.optionList, moreList);
            } else {
              this.optionList = [...this.optionList, ...moreList];
            }
            // 是否有下一页
            this.more = response.data.last > response.data.page;
            this.nextPage = response.data.page + 1;
          },
          (response) => {
            this.$sys.alarmResponse(response);
          }
        )
        .finally(() => {
          this.$nextTick(() => {
            this.adding = false;
          });
        });
    },
    // filterable == false 初始值和返回值重复去重
    listProcess(orgList, newList) {
      const oldList = [...orgList]; // 防止remove改变原值
      if (this.initOptionList.length > 0) {
        // 初始值keys
        const keys = this.initOptionList.map((item) => item[this.valueKey]);
        const removeIds = []; // 重复的keys
        newList.forEach((n) => {
          if (keys.indexOf(n[this.valueKey]) !== -1) {
            removeIds.push(n[this.valueKey]);
          }
        });
        // 删除原数组中的重复key的项
        _.remove(oldList, (n) => removeIds.indexOf(n[this.valueKey]) !== -1);
      }
      return [...oldList, ...newList];
    },
    selected() {
      if (this.multiple && this.filterable && this.multipleClear) {
        this.$refs.select.query = "";
      }
    },
    visibleChange(value) {
      // 第一次点击展开canQuery是false时，执行查询（如果有currentList值会包含currentList值）
      if (value && !this.canQuery) {
        this.canQuery = false;
        this.searchOptions("", true);
      }
      this.$emit("visible-change", value);
    },
    // 临时方法，测试用
    // temp() {},
  },
  watch: {
    value(val) {
      if (this.emptyValue !== val) {
        this.theValue = val;
      } else {
        this.theValue = "";
      }
    },
    // el-select 的 v-model 值
    theValue(val) {
      if (this.emptyValue !== "" && val === "") {
        this.$emit("input", this.emptyValue);
        this.$emit("change", this.emptyValue);
      } else {
        this.$emit("input", val);
        this.$emit("change", val);
      }
      const tempVal = _.filter(this.optionList, (item) => {
        let result = false;
        if (Array.isArray(val)) {
          result = val.indexOf(item[this.valueKey]) > -1;
        } else {
          result = item[this.valueKey] === val;
        }
        return result;
      });
      if (tempVal.length > 0) {
        this.$emit("valChange", [...tempVal]);
      } else if (val && this.currentList.length > 0) {
        // val 存在 而 optionList 没有对应值时，取初始化的值（可能还没来得及加载）
        // 这里不用initOptionList,是因为，同时修改select2的v-model 和currentList情况时，theValue先watch到
        // currentList 的watch还没有执行时会出错，
        this.$emit("valChange", [...this.currentList]);
      } else {
        this.$emit("valChange", []);
      }
    },
    // 修改初值
    currentList(val, old) {
      // 值相同时不用再麻烦去操作了
      if (_.isEqual(old, val) && _.isEqual(this.paramsStore, this.urlParams)) {
        return;
      }
      // 不是正确格式的设置成空
      if (
        !Array.isArray(val) ||
        (val.length > 0 && val[0][this.valueKey] === undefined)
      ) {
        this.currentList = [];
        return;
      }
      this.initOptionList = val;
      this.defaultOptions();
    },
    urlParams(val, old) {
      if (!_.isEqual(old, val)) {
        this.initOptionList = [];
        this.defaultOptions();
      }
    },
  },
};
</script>
